export enum Size {
  small = 's',
  medium = 'm',
  large = 'l',
}

export enum InstrumentState {
  inCommand = 'inCommand',
  active = 'active',
  loading = 'loading',
  off = 'off',
}
